import useOngoingChargingSession from 'hooks/useOngoingChargingSession';
import useOngoingParkingSession from 'hooks/useOngoingParkingSession';
import { useMemo } from 'react';
import { useParkingStore } from 'stores/parkingStore';
import { OngoingSessionType, ParkingZoneType } from 'types/common';

const useOngoingMultipleSession = () => {
  const { allParkingSessions } = useOngoingParkingSession();
  const { ongoingChargingSession } = useOngoingChargingSession();
  const selectedSession = useParkingStore(
    (state) => state.selectedOngoingSession
  );
  const allData = useMemo((): OngoingSessionType[] => {
    if (!ongoingChargingSession) {
      return allParkingSessions as OngoingSessionType[];
    }
    return [
      ...(allParkingSessions || []),
      ...(ongoingChargingSession ? [ongoingChargingSession] : []),
    ] as OngoingSessionType[];
  }, [allParkingSessions, ongoingChargingSession]);

  const sessionToShow: ParkingZoneType | 'MULTIPLE' = useMemo(() => {
    if (selectedSession) {
      return selectedSession;
    }
    if (allData.length > 1) {
      return 'MULTIPLE';
    }
    return allData?.find(Boolean)?.chargingSessionId ? 'CHARGING' : 'PARKING';
  }, [allData, selectedSession]);

  return {
    parkAndChargeData: allData,
    sessionToShow,
  };
};

export default useOngoingMultipleSession;
